import GuidLookupResourceListResultModel from '../../generated/types/model/resource/GuidLookupResourceListResultModel';

export default class GuidLookupResourceListResultViewModel extends GuidLookupResourceListResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
